import { WidenImage } from '@common/Widen/WidenImage';
import type { WidenMediaElement } from '@libs/widen-utils';

export interface TechnicalDiagramProps {
  diagram: WidenMediaElement;
}

export const TechnicalDiagram = ({ diagram }: TechnicalDiagramProps) => (
  <div className="md:flex border-b-2 border-gray-200">
    <div className="py-8">
      <WidenImage height={250} width={375} shortCode={diagram.shortCode} filename={diagram.filename} />
      <div
        className="px-3 py-5"
        data-testid="technical-diagram-underline"
        dangerouslySetInnerHTML={{
          __html: diagram.underline ?? '',
        }}
      />
    </div>
    <div
      className="md:py-8 md:px-12 sm:pb-8"
      dangerouslySetInnerHTML={{
        __html: diagram.description ?? '',
      }}
    />
  </div>
);
